var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.ratingComponent,{tag:"component",attrs:{"id":_vm.id,"is-loading":_vm.isLoading,"rating":_vm.rating},on:{"reloadRating":_vm.reloadRating}})
}
var staticRenderFns = []

export { render, staticRenderFns }